'use client';

import styles from './Dropdown.module.scss';
import Button from '@/app/_components/common/button/Button';
import { ReactNode, useEffect, useRef, useState } from 'react';
import usePostLogout from '@/app/_hooks/queries/usePostLogout';
import useAccountStore from '@/app/_stores/accountStore';
import UserProfile from '@/app/_components/common/user-profile/UserProfile';
import IconArrowDown from '@/app/_images/ico_arrow_down.svg';

interface DropdownProps {
  items: ReactNode[];
  checkIndex?:number;
}

const Dropdown = ({ items, checkIndex }: DropdownProps) => {
  const { mutate: postLogout } = usePostLogout();
  const { email } = useAccountStore((state) => state.userInfo);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const updatePosition = () => {
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      setPosition({ top: buttonRect.bottom, left: buttonRect.left + 48 });
    }
  };

  useEffect(() => {
    if (isOpen) {
      updatePosition();

      const handleResize = () => updatePosition();
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        hideDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    updatePosition();
  };

  const hideDropdown = () => {
    setIsOpen(false);
  };

  const logout = () => {
    postLogout();
  };

  return (
    <div ref={dropdownRef}>
      <div className={styles.triggerContainer}>
        <Button ref={buttonRef} variants="text-primary" onClick={toggleDropdown}>
          <UserProfile userInfo={email} />
        </Button>
        <div
          className={`${styles.dropdownIndicator}  ${isOpen ? styles.open : ''}`}
          onClick={toggleDropdown}
        >
          <IconArrowDown />
        </div>
      </div>
      <ul
        className={`${styles.dropdownContainer} ${isOpen ? styles.open : ''}`}
        style={{ top: position.top, left: position.left, position: 'absolute' }}
      >
        {items.map((item, index) => (
          <li key={index} onClick={hideDropdown} className={`${checkIndex===index?`${styles.itemChecked}`:''}`}>
            {item}
          </li>
        ))}
        <li onClick={hideDropdown}>
          <button onClick={logout} className={'text-danger'}>
            ログアウト
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Dropdown;
